(() => {
  'use strict';
  const rank = label => ({innbunden:10, innbundet:10, hefta:20, heftet:20, pocket:25, 'e-bøker':30, 'e-bok':30, lydbøker:40, lydbok:40, 'digital lydbok':40, lydfil:40}[label.toLowerCase()] || 90);
  async function enhance(link) {
    if (link.dataset.loading) return;
    link.dataset.loading = 'true';
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.set('view', 'v3-formats');
      const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(8000)});
      if (!response.ok) return;
      const data = await response.json();
      if (data.group !== link.dataset.formatGroup || data.complete !== true || !Array.isArray(data.products) || data.products.length > 250) return;
      const seen = new Set();
      const products = [];
      for (const item of data.products) {
        if (!item || typeof item.id !== 'string' || !/^\d+$/.test(item.id) || typeof item.url !== 'string' || typeof item.format !== 'string' || !item.format.trim()) return;
        const target = new URL(item.url, location.origin);
        if (target.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+$/.test(target.pathname) || target.search || target.hash) return;
        if (seen.has(item.id)) continue;
        seen.add(item.id);
        const label = item.format.trim();
        products.push({...item, url:target.pathname, label, rank:rank(label)});
      }
      if (!seen.has(link.dataset.productId)) return;
      if (products.length < 2) { link.remove(); return; }
      const labels = products.map(item => item.rank === 30 ? 'E-bok' : item.rank === 40 ? 'Lydbok' : item.label.toLowerCase());
      if (new Set(labels).size < products.length) {
        link.textContent = new Set(labels).size === 1 ? 'Fleire utgåver' : 'Fleire format og utgåver';
        return;
      }
      products.sort((a,b) => a.rank - b.rank || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
      const fragment = document.createDocumentFragment();
      for (const item of products) {
        const active = item.id === link.dataset.productId;
        const node = document.createElement(active ? 'span' : 'a');
        node.className = 'v3-pdp-hero__format' + (active ? ' v3-pdp-hero__format--active' : '');
        node.textContent = item.rank === 30 ? 'E-bok' : item.rank === 40 ? 'Lydbok' : item.label;
        if (active) node.setAttribute('aria-current','true');
        else node.setAttribute('href',item.url);
        fragment.append(node);
      }
      const container = link.closest('.v3-pdp-hero__formats');
      if (container && link.isConnected) container.replaceChildren(fragment);
    } catch (_) { /* Keep the working collection link if the enhancement fails. */ }
  }
  document.querySelectorAll('[data-v3-format-fallback]').forEach(enhance);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-v3-format-fallback]').forEach(enhance));
})();
